export default "__VITE_ASSET__93227ea3__"